import React from 'react'

const Communication = () => {
  return (
    <div>
      <div>
        <h3>Ways with words</h3>
        <p className='question'>A. The words in the crossword puzzle are from the text. Find them in the text to solve the puzzle based on the clues given below.</p>
        <strong>Down</strong>
        <p>1. to be preoccupied with a single topic or emotion <strong>obsessed</strong></p>
        <p>3. to move slowly and quietly in a particular direction <strong>creep</strong></p>
        <p>4. orderly, logical and consistent<strong> coherent</strong></p>
        <strong>Across</strong>
        <p>2. to utter rapidly or unintelligibly <strong>babble</strong></p>
        <p>5. to insert something between other things <strong>interpose</strong></p>
        <p>6. an unreadable handwriting<strong> squiggle</strong></p>
      </div>
      <hr/>
      <div>
        <p className='question'>B. Use the following words in sentences of your own.</p>
        <p><strong>Massive:</strong></p>
        <p>The earthquake caused massive destruction in the city, leaving many buildings in ruins.</p>
        <p><strong>Consciousness:</strong></p>
        <p>After the accident, he slowly regained consciousness and realized he was in a hospital.</p>
        <p><strong>Catch-as-catch-can:</strong></p>
        <p>During the power outage, we had a catch-as-catch-can dinner using whatever we found in the fridge.</p>
        <p><strong>Give up:</strong></p>
        <p>Even though the journey was tough, she refused to give up and kept moving forward.</p>
        <p><strong>Abandon:</strong></p>
        <p>Due to the storm, the hikers had to abandon their plan to reach the summit.</p>
        <p><strong>Lousy:</strong></p>
        <p>I felt lousy all day because I hadn't slept well the night before.</p>
        <p><strong>Editing:</strong></p>
        <p>Good writing often requires several rounds of editing to correct errors and improve clarity.</p>
      </div>
      <hr/>
      <div>
        <p className='question'>Write the following words in the right columns. Change the adjectives into adverbs and nouns into adjectives.</p>
        <p>Adjectives: Careful ,  	Adverbs: Carefully</p>
        <p>Adjectives: Perfect  , Adverbs: Perfectly</p>
        <p>Adjectives: Automatic ,  Adverbs: Automatically</p>
        <p>Adjectives: Certain  , 	Adverbs: Certainly</p>
        <p>Adjectives: Fair  ,   Adverbs: Fairly</p>
        <p>Adjectives: General ,  Adverbs: Generally</p>
        <p>Adjectives: Proud ,  Adverbs: Proudly</p>
        <p>Adjectives: Rapid  , 	Adverbs: Rapidly</p>
        <p>Adjectives: Proper ,  Adverbs: Properly</p>
        <p>Adjectives: Final  , 	Adverbs: Finally</p>
        <p>Adjectives: Common ,  Adverbs: Commonly</p>
        <p>Adjectives: Beautiful , Adverbs: Beautifully</p>
        <p>Adjectives: Frequent ,  Adverbs: Frequently</p>
        <p>Adjectives: Heavy ,  Adverbs: Heavily</p>
        <p>Adjectives: Hungry ,  Adverbs: Hungrily</p>
      </div>
      <hr/>
      <div>
        <p>Nouns: Rain  ,  Adjectives: Rainy</p>
        <p>Nouns: Bush  , Adjectives: Bushy</p>
        <p>Nouns: Spice , Adjectives: Spicy</p>
        <p>Nouns: Snow  , Adjectives: Snowy</p>
        <p>Nouns: Blood , Adjectives: Bloody</p>
        <p>Nouns: Cloud ,  Adjectives: Cloudy</p>
        <p>Nouns: Bag  ,  Adjectives: Baggy</p>
        <p>Nouns: Mood , Adjectives: Moody</p>
        <p>Nouns: Air ,  Adjectives: Airy</p>
        <p>Nouns: Cream ,  Adjectives: Creamy</p>
        <p>Nouns: Dust ,  Adjectives: Dusty</p>
        <p>Nouns: Ice ,  Adjectives: Icy</p>
        <p>Nouns: Fun  , Adjectives: Funny</p>
        <p>Nouns: Ease ,  Adjectives: Easy</p>
        <p>Nouns: Hand ,  Adjectives: Handy</p>
        <p>Nouns: Oil , Adjectives: Oily</p>
        <p>Nouns: Greed  ,  Adjectives: Greedy</p>
        <p>Nouns: Health ,  Adjectives: Healthy</p>
        <p>Nouns: Hill ,  Adjectives: Hilly</p>
      </div>
      <hr/>
      <div>
        <p className='question'>c. Fill in the gaps with the appropriate adjective or adverb.</p>
        <p>i. Pramila is playing <u>quietly</u> (quiet/quietly).</p>
        <p>ii. Hari speaks very <u>loudly</u> (loud/loudly).</p>
        <p>iii. Mukesh is a <u>careful</u> (careful/carefully) driver.</p>
        <p>iv. The test was <u>easy</u> (easy/easily) and we finished in time.</p>
        <p>v. He is fitting the <u>automatic</u> (automatic/automatically) door in my house.</p>
        <p>vi. My uncle speaks <u>perfect</u> (perfect/perfectly) Chinese.</p>
        <p>vii. It was raining very <u>heavily</u> (heavy/heavily).</p>
        <p>viii. She looked very <u>calm</u> (calm/calmly), but I am sure she was feeling very nervous.</p>
      </div>
      <hr/>
      <div>
        <h3>Comprehension</h3>
        <p  className='question'>Answer the following questions.</p>
        <p  className='question'>a. Why is freewriting also called 'automatic writing'?</p>
        <p>= Freewriting is also called 'automatic writing' because it involves writing continuously without worrying about grammar, spelling, punctuation, or staying on a specific topic. The writer allows thoughts to flow freely onto the page without self-censorship, making the process automatic and unfiltered.</p>
        <p className='question'>b. How do you differentiate writing from speaking?</p>
        <p>= Writing is a planned and editable form of communication that allows the writer to organize thoughts logically and revise the content before sharing. It serves as a permanent record and can be referred to in the future. In contrast, speaking is spontaneous, often less structured, and typically happens in real-time. It is temporary and usually not recorded unless intentionally done so.</p>
        <p className='question'>c. What is the biggest obstacle in the writing process, according to Elbow? Do you agree with him? Why? Why not?</p>
        <p>= According to Elbow, the biggest obstacle in the writing process is overthinking about grammar, spelling, and correctness while writing. I agree with him because worrying about these things too early can block the natural flow of ideas. Freewriting encourages expression without fear, helping writers improve their creativity and confidence.</p>
        <p  className='question'>d. How can freewriting overcome 'writer's block'?</p>
        <p>= Writer's block is the hesitation or struggle to begin writing due to fears about grammar, coherence, or choosing the right words. Freewriting helps overcome this by allowing writers to express any thoughts freely without worrying about correctness or structure. This removes pressure and helps ideas flow naturally, making it easier to start writing.</p>
        <p className='question'>e. What do you mean by 'voice' in writing?</p>
        <p>= In writing, 'voice' refers to the unique style, tone, and personality that a writer brings to their work. It includes word choice, sentence structure, and the overall way ideas are expressed.</p>
        <p className='question'>f. Elbow uses a simile to explain that freewriting “is like writing something and putting it in a bottle in the sea.” What does this mean? Explain.</p>
        <p>= This simile means that freewriting is a private and unfiltered form of writing, not meant for others to read or judge. Just like a message in a bottle thrown into the sea may never be found, freewriting is done without the pressure of audience or criticism. It allows the writer to express thoughts freely, without worrying about perfection.</p>
      </div>
      <hr/>
      <div>
        <h3>Writing</h3>
        <p  className='question'>C. Write a paragraph on any one of the following topics.</p>
        <p className='question'>a. My School Library</p>
        <strong>My School Library</strong>
        <p  >= A library is a place where a large collection of books, journals, and other reading materials are kept for people to read or borrow. It plays an important role in education by providing access to knowledge, encouraging reading habits, and supporting learning beyond textbooks. Libraries are quiet places that help students focus and study in a peaceful environment. They also help develop discipline, research skills, and a love for reading.</p>
        <p>My school library is very organized and student-friendly. Students can borrow up to three books at a time using their library card. Each book is issued for 15 days, and if not renewed on time, a fine of Rs. 5 is charged per day. If a book is lost, the student must pay the full price of the book. The library has two main sections: one for course books arranged in order by subject, and another called the "out book" section, which includes novels, biographies, poems, essays, stories, and entrance exam preparation books. A computer system is used to keep track of book records and borrowing history. The library also has a quiet reading area with tables, chairs, and green plants, creating a peaceful and pleasant environment for study.</p>
        <p>Overall, my school library is a valuable resource that supports students' learning and helps create a quiet, comfortable space for reading and studying.</p>
      </div>
      <hr/>
      <div>
        <p className='question'>b. Moral Values I Like Most</p>
          <strong>Moral Values I Like Most</strong>
          <p>= Moral values are the principles and beliefs that help us understand what is right and wrong. They guide our behavior and decisions, helping us live a good and honest life. These values are important because they create harmony and trust in our families, communities, and society as a whole. Without moral values, it would be difficult to maintain peace and order in our daily lives.</p>
          <p>In a family, I believe respecting parents is very important. Helping them with daily tasks and showing love to younger siblings or juniors strengthens family bonds. Always smiling and greeting others warmly creates a happy environment at home. It is also important to guide each other by showing what is right and what is wrong, so everyone grows up with good habits and values.</p>
          <p>As a responsible citizen, I value truthfulness and living free from corruption. Fighting against violence, discrimination, and superstitious beliefs is necessary to build a fair society. I also support helping with plantation and keeping the environment clean to protect nature. Loving and caring for animals and maintaining peace in the community are essential moral values that I admire and try to follow every day.</p>
          <p>In conclusion, moral values are the foundation of a good life and a healthy society. By practicing these values both at home and as citizens, we can create a peaceful, respectful, and caring world for everyone.</p>
      </div>
      <hr/>
      <div>
        <h3>Grammar</h3>
        <p className='question'>B. Rewrite the following sentences with the adverbs in the appropriate place.</p>
        <p>i. I watch television. (often)</p>
        <p>= I often watch television.</p>
        <p>ii. Have you been to Janakpur? (ever)</p>
        <p>= Have you ever been to Janakpur.</p>
        <p>iii. They play football on Saturday. (sometimes)</p>
        <p>= They sometimes play football on Saturday.</p>
        <p>iv. The weather is bad in November. (always)</p>
        <p>= The weather is always bad in November.</p>
        <p>v. We have fish for dinner. (seldom)</p>
        <p>= We seldom have fish for dinner.</p>
        <p>vi. Pritam doesn't get up before seven. (usually)</p>
        <p>= Pritam usually gets up after seven.</p>
        <p>vii. I was very tired and I was hungry. (also)</p>
        <p>= I was very tired and I was also hungry.</p>
        <p>viii. Did you enjoy the flight? (both)</p>
        <p>= Did you both enjjoy the flight?</p>
      </div>
      <hr/>
      <div>
        <p className='question'>C. Rewrite the following sentences placing the underlined words in the right position.</p>
        <p>i. I never have understood her.</p>
        <p>= I have never understood her.</p>
        <p>ii. We are often invited to the parties.</p>
        <p>= We are often invited to the parties.</p>
        <p>iii. We all were tired, so we all fell asleep.</p>
        <p>= We were all tired, so we all fell asleep.</p>
        <p>iv. Rajan drives always to work.</p>
        <p>= Rajan always drives to work.</p>
        <p>v. Pradip hardly ever watches television, but he reads newspapers a lot.</p>
        <p>= Pradip hardly ever watches television, but he read newspaper a lot.</p>
        <p>vi. We enjoyed very much the party.</p>
        <p>= We enjoyed the party very much.</p>
        <p>vii. My brother speaks fluently English.</p>
        <p>= My brother speaks English fluently.</p>
      </div>
    </div>
  )
}

export default Communication
